import { FormControl, InputLabel, SxProps, Theme } from "@mui/material";
import { WorkItemInputField } from "./WorkItemInputStyles";

interface IWorkItemProps {
    label: string,
    idSuffix: string,
    labelProps?: SxProps<Theme> | undefined,
    onChange?: (e: any) => void
}

const WorkItemTextInput = (props: IWorkItemProps) => {
    return (
        <FormControl 
            sx={{ paddingRight: 1 }} 
            variant="standard" 
            fullWidth>
            <InputLabel 
                shrink 
                sx={props.labelProps}
                htmlFor={"work-item-input-"+props.idSuffix}>
                {props.label}:
            </InputLabel>
            <WorkItemInputField 
                defaultValue="" id={"work-item-input-"+props.idSuffix} 
                fullWidth 
                onChange={props.onChange}/>
        </FormControl>
    );
}

export default WorkItemTextInput;